import React from 'react';
import cn from 'classnames';

// eslint-disable-next-line no-restricted-imports
import './ModuleText.scss';

const ModuleText = ({
	text = '',
	contentfulField = null,
	colorVariant = 'white'
}) => {
	const regexMap = [
		{regex: /\*([^*]+)\*/g, replacement: '<i>$1</i>'},
		{regex: /__([^_]+)__/g, replacement: '<b>$1</b>'},
		{regex: /\r?\n/g, replacement: '</br>'},
		{regex: /\[([^\]]+)\]\((https?:\/\/[^)]+)\)/g, replacement:'<a href="$2">$1</a>'}
	];

	if (!text) {
		return null;
	}

	let textToRender = text;

	regexMap.forEach(({regex, replacement}) => {
		textToRender = textToRender.replace(regex, replacement);
	});

	if (textToRender.startsWith('###')) {
		return <h3
			className={cn(`module__${contentfulField}`, `text-color__${colorVariant}`)}
			dangerouslySetInnerHTML={{__html: textToRender.replace('### ', '')}}
		/>;
	}

	if (textToRender.startsWith('##')) {
		return <h2
			className={cn(`module__${contentfulField}`, `text-color__${colorVariant}`)}
			dangerouslySetInnerHTML={{__html: textToRender.replace('## ', '')}}
		/>;
	}

	if (textToRender.startsWith('#')) {
		return <h1
			className={cn(`module__${contentfulField}`, `text-color__${colorVariant}`)}
			dangerouslySetInnerHTML={{__html: textToRender.replace('# ', '')}}
		/>;
	}

	return <p
		className={cn(`module__${contentfulField}`, `text-color__${colorVariant}`)}
		dangerouslySetInnerHTML={{__html: textToRender}}
	/>;
};

export default ModuleText;
